import React, { useState, useEffect } from "react";
import {
  Button,
  TextField,
  DialogTitle,
  Dialog,
  Box,
  Typography,
  IconButton,
  InputLabel, // Keep InputLabel for clarity if preferred, but not strictly needed with MUI TextField
} from "@mui/material";
import { useTheme } from "@mui/material/styles"; // Import useTheme
import { useDispatch } from "react-redux";

import { updateIngredient, saveCurrentRecipe } from "../actions/recipes";
import { Close } from "@mui/icons-material";

// Removed: import { makeStyles } from "@mui/styles";
// Removed: useStyles definition

function EditIngredient(props) {
  const { onClose, open, currentIngredient } = props;
  const dispatch = useDispatch();
  const theme = useTheme(); // Access the theme

  // Initialize state, ensure amount is treated as a number
  const [name, setName] = useState(currentIngredient.name || "");
  const [measurement, setMeasurement] = useState(
    currentIngredient.measurement || ""
  );
  const [amount, setAmount] = useState(currentIngredient.amount || 0);

  // --- useEffect to update state when currentIngredient prop changes ---
  useEffect(() => {
    // Only update if currentIngredient exists
    if (currentIngredient) {
      setName(currentIngredient.name || "");
      setMeasurement(currentIngredient.measurement || "");
      setAmount(currentIngredient.amount || 0);
    }
  }, [currentIngredient]);

  // --- Handlers ---
  const handleClose = () => onClose();
  const handleNameChange = (e) => setName(e.target.value);
  // Ensure the amount change handles both string and number types
  const handleAmountChange = (e) => setAmount(e.target.value);
  const handleMeasurementChange = (e) => setMeasurement(e.target.value);

  // --- Submission Logic ---
  function editItem() {
    // New ingredient object with updated form data
    const newIngredient = {
      uuid: currentIngredient.uuid,
      amount: parseFloat(amount), // Convert amount to number for safety
      name: name,
      measurement: measurement,
    };

    // update ingredient in redux
    dispatch(updateIngredient(newIngredient));
    dispatch(saveCurrentRecipe());
    handleClose();
  }

  // Define styles using the sx prop
  const closeButtonStyle = {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  };
  // Style for full-width input fields
  const inputStyle = { mb: 2, mt: 1 };

  return (
    <Dialog
      maxWidth={"xs"}
      fullWidth={true}
      onClose={handleClose}
      aria-labelledby="edit-ingredient"
      open={open}
    >
      <DialogTitle
        id="edit-ingredient"
        sx={{
          borderBottom: `1px solid ${theme.palette.divider}`,
          padding: theme.spacing(2, 3),
        }}
      >
        <Typography variant="h5" component="span" sx={{ fontWeight: 600 }}>
          🥄 Edit Ingredient
        </Typography>
        <IconButton
          aria-label="close"
          sx={closeButtonStyle}
          onClick={handleClose}
        >
          <Close />
        </IconButton>
      </DialogTitle>

      <Box
        component="form"
        noValidate
        autoComplete="off"
        sx={{
          p: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <TextField
          fullWidth
          label="Name"
          placeholder="Enter the ingredient name"
          onChange={handleNameChange}
          value={name}
          sx={inputStyle}
        />

        <TextField
          fullWidth
          label="Measurement"
          placeholder="Enter the measurement unit (e.g., cup, tsp, oz)"
          onChange={handleMeasurementChange}
          value={measurement}
          sx={inputStyle}
        />

        <TextField
          fullWidth
          label="Amount"
          type="number"
          placeholder="Enter the quantity"
          inputProps={{ step: 0.1 }}
          onChange={handleAmountChange}
          value={amount}
          sx={inputStyle}
        />
      </Box>

      <Box
        sx={{
          p: 3,
          display: "flex",
          justifyContent: "center",
          borderTop: `1px solid ${theme.palette.divider}`,
        }}
      >
        <Button
          onClick={editItem}
          size="large"
          variant="contained"
          color="primary"
          sx={{ padding: theme.spacing(1, 4) }}
        >
          Save Changes
        </Button>
      </Box>
    </Dialog>
  );
}
export default EditIngredient;
